import { ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID, ECLIPSE_BUSINESS_ELITE_PRODUCT_FAMILY_ID } from '@wix/package-picker-shared';

/**
 * Product families that show the Base44 voucher card. There is no
 * voucher-eligibility flag in the product data, so we match the two known
 * family IDs (the established family-ID-targeting pattern in this codebase).
 */
export const BASE44_VOUCHER_FAMILY_IDS = [ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID, ECLIPSE_BUSINESS_ELITE_PRODUCT_FAMILY_ID];
export const shouldShowBase44Voucher = _ref => {
  let {
    productFamilyId,
    isExperimentEnabled
  } = _ref;
  return isExperimentEnabled && productFamilyId != null && BASE44_VOUCHER_FAMILY_IDS.includes(productFamilyId);
};
//# sourceMappingURL=shouldShowBase44Voucher.js.map